<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h1 class="mb-3">{{ $t('bulk_orders_import.bulk_orders_import') }}</h1>
        <v-card outlined class="mb-3">
            <bulk-orders-import-table :warehouse-id="warehouseId"/>
        </v-card>
    </layout-authenticated>
</template>

<script>
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated.vue";
import BulkOrdersImportTable from "@/components/user/bulkOrdersImport/BulkOrdersImportTable.vue";
import SnackbarMixin from "@/mixins/SnackbarMixin.vue";
import _ from "lodash";

export default {
    name: "BulkOrdersImport",
    mixins: [SnackbarMixin],
    components: {BulkOrdersImportTable, LayoutAuthenticated},
    computed: {
        breadcrumb() {
            return [
                {
                    text: this.$t('app.name'),
                    href: '/'
                },
                {
                    text: this.$t('bulk_orders_import.bulk_orders_import'),
                    href: '/bulk-orders-import',
                    disabled: true
                }
            ];
        },
        userId() {
            return this.$store.getters['identity/getUserId'];
        },
        warehouseId() {
            let warehouseId = _.toInteger(this.$store.getters['warehouse/getWarehouseId'](this.userId));
            if (warehouseId === null) {
                this.snackbarError(this.$t('snackbar.warehouses.not_selected'));
                return null;
            }
            return warehouseId;
        }
    }
}
</script>
